import { render, staticRenderFns } from "./ContractPDF.vue?vue&type=template&id=2ffa2345&"
import script from "./ContractPDF.vue?vue&type=script&lang=js&"
export * from "./ContractPDF.vue?vue&type=script&lang=js&"
import style0 from "./ContractPDF.vue?vue&type=style&index=0&id=2ffa2345&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports